import { Link } from 'react-router-dom'

export const Footer = () => {
  return (
    <footer className="relative mt-10 p-4 border-t border-border" style={{ zIndex: 1 }}>
      <div className="lobby-footer-blob-desktop">
        <div className="aurora-left" />
        <div className="aurora-right" />
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center gap-2 ">
          <img
            src="/db8ai-logo.webp"
            alt="DB8AI.com Logo"
            className="h-14 rounded-full border border-2 border-yellow-300"
          />
          <span className="font-bold text-lg pl-6">DB8AI.com</span>
        </div>
        <div className="flex gap-4 mt-4 md:mt-0">
          {/* <Link to="/privacy-policy" className="hover:underline">
            Privacy Policy
          </Link> */}
          <Link to="/privacy-policy" className="hover:underline">
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" className="hover:underline">
            Terms And Conditions
          </Link>
        </div>
      </div>
      <div className="mt-4 text-sm text-center">
        © {new Date().getFullYear()} DB8AI.com. All Rights Reserved.
      </div>
    </footer>
  )
}
